
    <cms-navbar></cms-navbar>
    <div style="padding: 20px">
      <ng-content></ng-content>
    </div>
  